module.exports = __webpack_public_path__ + "static/img/611617353325.50d3177f.jpg";